import { render, staticRenderFns } from "./zpin.vue?vue&type=template&id=4b0d2da2&scoped=true"
import script from "./zpin.vue?vue&type=script&lang=js"
export * from "./zpin.vue?vue&type=script&lang=js"
import style0 from "./zpin.vue?vue&type=style&index=0&id=4b0d2da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0d2da2",
  null
  
)

export default component.exports